import { useLocation } from "react-router";
import { extractCurrentFileId } from "../helpers/extractCurrentFileId";

function useCurrentFileId() {
  "use memo";
  const location = useLocation();
  const pathname = location.pathname;

  return extractCurrentFileId(pathname);
}

export { useCurrentFileId };
